import React from "react";
import { CheckboxField } from "../../../common/FormFields";
import "../../../common/FormFields/FormFields.css";

const moduleOptions = [
  { label: "Password", value: "password" },
  { label: "Signature", value: "signature" },
];

const SignatureAuthSection = ({ signatureMethods, onToggleMethod, disabled = false }) => {
  return (
    <div className="sig-section">
      <div className="sig-label">
        Select the Signature Authentication Method
        {!disabled && <span className="form-field-required">*</span>}
      </div>
      <div className="sig-options">
        {moduleOptions.map((opt) => (
          <CheckboxField
            key={opt.value}
            checked={signatureMethods.includes(opt.value)}
            onChange={() => onToggleMethod(opt.value)}
            description={opt.label}
            className="sig-option"
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  );
};

export default SignatureAuthSection;
